import { Component, OnInit, ElementRef, Inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

import { MatDialog, MatDialogRef, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { IClientsSocis, IClientsSocisResponse } from '../../clientsSocis/clientssocis.interfaces';
import { ClientsSocisService } from '../../services/clients_socis/clientsSocis.service';

@Component({
  selector: 'dialog-clientssocis',
  templateUrl: './dialog.component.clientssocis.html',
  styleUrls: ['./dialog.component.clientssocis.scss'],
  providers: [ClientsSocisService]
})
export class DialogClientsSocis {
  private clientSociModel: IClientsSocis = {
      'id': 'NEW',
      'nom': null,
      'tipus': null,
      'telefon': null,
      'adreca': null,
      'client': true,
      'soci': true,
      'localitzacio': null,
      'descripcio': null,
      'comentari': null,
      'web': null,
      'mail': null,
      'country': null,
      'cif': null
  };
  private id: string;
  public error: string = '';
  public showAsyncProgress: boolean = false;
  public editClientSociData: IClientsSocis;
  public possibleTipus: Array<string> = [];
  public possiblePaisos: Array<string> = [];

  constructor(public translate: TranslateService, public languageService: LanguageService, private clientsSocisService: ClientsSocisService, public dialogRef: MatDialogRef<DialogClientsSocis>, @Inject(MAT_DIALOG_DATA) public data: any){ 
    this.editClientSociData =  data;
    this.clientsSocisService.getClientSociTipus()
      .subscribe(
        data=> {this.possibleTipus = data.filter(elem => elem.nom != '').map(item => item.nom);},
        error => console.log(error)
      );

    this.clientsSocisService.getAutocomplete("countryCliSoc")
      .subscribe(
        data=> {this.possiblePaisos = data.filter(elem => elem.text != '').map(item => item.text);},
        error => console.log(error)
      );
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  desar(): void {
    if(this.editClientSociData.nom == "" || !this.editClientSociData.nom){alert("Cal omplir el camp Nom/Sigles.");return;}
    if(this.editClientSociData.tipus == "" || !this.editClientSociData.tipus){alert("Cal omplir el camp tipus d'empresa.");return;}
    this.dialogRef.close(this.editClientSociData);
  }

  close(): void {
    this.dialogRef.close(null);
  }

  ngOnInit(){ }

}
